import { type MaybeRef, ref, computed } from "vue";

export default function useImageOptimization(image?: MaybeRef<string|undefined>) {
  image = ref(image);

  function optimize(imageUrl: string, quality?: string): string {
    try{
      let url = new URL(imageUrl);
      url.searchParams.set("quality", quality ?? "70");
      url.searchParams.set("format", "webp");
      return url.toString();
    }catch(e){
      return '';
    }
  }

  const optimizedImageUrl = computed(() => {
    if (!image?.value) return;
    let isBuilderImage = image.value.includes("builder") && image.value.includes("image");
    if (isBuilderImage) {
      return optimize(image.value);
    }

    return image.value
  });

  return {
    optimize,
    optimizedImageUrl,
  };
}
